import { render, staticRenderFns } from "./TargetingBlock.vue?vue&type=template&id=50d25017&scoped=true&"
import script from "./TargetingBlock.vue?vue&type=script&lang=ts&"
export * from "./TargetingBlock.vue?vue&type=script&lang=ts&"
import style0 from "./TargetingBlock.vue?vue&type=style&index=0&id=50d25017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d25017",
  null
  
)

export default component.exports